const getDefaultState = () => ({
  routeHistory: [],
});

const state = getDefaultState();

const getters = {
  routeHistory(state) {
    return state.routeHistory;
  },
};

const mutations = {
  SET_ROUTE_HISTORY(state, payload) {
    state.routeHistory = Array.isArray(payload) ? [...payload] : [];
  },
  CLEAR_ROUTE_HISTORY(state) {
    state.routeHistory = [];
  },
  POP_ROUTE_HISTORY(state) {
    if (state.routeHistory.length) state.routeHistory.pop();
  },
};

const actions = {
  setRouteHistory({ commit }, routes) {
    commit('SET_ROUTE_HISTORY', Array.isArray(routes) ? routes : []);
  },
  clearRouteHistory({ commit }) {
    commit('CLEAR_ROUTE_HISTORY');
  },
  popRouteHistory({ commit }) {
    commit('POP_ROUTE_HISTORY');
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
